import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from '@anytag/shared-atoms';
import { useToggleState } from '@anytag/shared-hooks';
import {
  EngagementCampaignTrafficSourceModal,
  EngagementCampaignTrafficSourceModalProps
} from './EngagementCampaignTrafficSourceModal';

interface EngagementCampaignTrafficSourceProps extends ButtonProps, EngagementCampaignTrafficSourceModalProps {}

export const EngagementCampaignTrafficSource = ({
  filter,
  campaignId,
  ...restProps
}: EngagementCampaignTrafficSourceProps) => {
  const { t } = useTranslation();
  const modalState = useToggleState();

  return (
    <>
      <Button
        variant="outline"
        onClick={modalState.open}
        title={t('Traffic Source')}
        prefixIcon={{ icon: 'bar-chart', size: 12 }}
        {...restProps}
      />

      <EngagementCampaignTrafficSourceModal
        filter={filter}
        campaignId={campaignId}
        open={modalState.status}
        onClose={modalState.close}
      />
    </>
  );
};
